<template>
	<Modal
		title="Recalculate Matrix"
		:closeOnOverlayClick="false"
		:visible="modalVisible"
		@close="onCancel"
	>
		<template v-slot:body>
			<div class="recalculate-matrix__body">
				<span>
					Recalculating might affect the manually overridden rates in
					the custom matrix.
				</span>
				<RadioGroup
					labelText="Do you want to recalculate all rates, including overridden rates?"
					:options="radioOptions"
					v-model="radioSelection"
				/>
			</div>
		</template>

		<template v-slot:footer>
			<div>
				<ButtonSet>
					<ButtonClassic
						variant="primary"
						labelText="Recalculate"
						@click="onRecalculate"
						ref="recalculateButton"
					/>
					<ButtonClassic
						variant="text"
						labelText="Cancel"
						@click="onCancel"
					/>
				</ButtonSet>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/shells/modal/modal.vue';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import ButtonSet from '@/components/forms/button/button-set.vue';
import RadioGroup from '@/components/forms/selection-control/radio/radio-group.vue';

export default {
	name: 'RecalcMatrixConfirmationModal',
	components: {
		Modal,
		ButtonClassic,
		ButtonSet,
		RadioGroup
	},
	data() {
		return {
			modalVisible: this.visible,
			radioSelection: 'yes',
			radioOptions: [
				{
					text: 'Yes, recalculate all rates.',
					value: 'yes'
				},
				{
					text: 'No, recalculate only non-overridden rates.',
					value: 'no'
				}
			]
		};
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onRecalculate() {
			this.$emit('recalc', this.radioSelection);
			this.modalVisible = false;
		},
		onCancel() {
			this.$emit('close');
			this.modalVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.recalculate-matrix {
	&__body {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
		width: 400px;
		font-size: $txt-font-size;
		color: var(--bg-0-fg-4);
	}
}
</style>
